import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import styles from './Modal.module.scss';
import { withPrefix } from 'gatsby-link';

ReactModal.setAppElement(`#___gatsby`);

const overlayStyles = {
  zIndex: 102
};

export default class Modal extends Component {
  render() {
    const { isOpen, handleClose, children } = this.props;
    const modalStyles = { overlay: overlayStyles };

    return (
      <ReactModal
        isOpen={isOpen}
        style={modalStyles}
        shouldCloseOnEsc={true}
        className={styles.modal}
      >
        <div className={styles.close} onClick={handleClose}>
          <img src={withPrefix('/close_x.svg')}/>
        </div>
        <div className={styles.content}>
          {children}
        </div>
      </ReactModal>
    );
  }
};

Modal.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  children: PropTypes.node
};



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.jsx